import { FC, useEffect, useState } from 'react';
import { useWallet } from '@solana/wallet-adapter-react';

interface LeaderboardEntry {
  wallet: string;
  wins: number;
  timestamp: number;
}

const Leaderboard: FC = () => {
  const { publicKey } = useWallet();
  const [leaderboardData, setLeaderboardData] = useState<LeaderboardEntry[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadLeaderboard = async () => {
      try {
        const response = await fetch('/api/whitelist/leaderboard');
        const data = await response.json();
        if (data.success) {
          setLeaderboardData(data.entries);
        }
      } catch (error) {
        console.error('Error loading leaderboard:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadLeaderboard();
    // Refresh leaderboard every 30 seconds
    const interval = setInterval(loadLeaderboard, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-[#1A2634] rounded-2xl p-6">
      <h2 className="text-2xl font-bold gaming-text mb-6 text-center">Top Players</h2>
      
      {isLoading ? (
        <div className="text-center py-8">Loading...</div>
      ) : leaderboardData.length === 0 ? (
        <div className="text-center py-8 text-gray-400">
          No battles recorded yet. Be the first champion!
        </div>
      ) : (
        <div className="space-y-4">
          {/* Header */}
          <div className="grid grid-cols-4 gap-4 px-4 py-2 bg-[#2A3644] rounded-lg font-bold text-sm text-gray-400 code-mono">
            <div>RANK</div>
            <div>PLAYER</div>
            <div className="text-center">WINS</div>
            <div className="text-center">LAST BATTLE</div>
          </div>

          {/* Leaderboard Entries */}
          {leaderboardData.map((entry, index) => (
            <div
              key={entry.wallet}
              className={`grid grid-cols-4 gap-4 px-4 py-3 rounded-lg ${
                publicKey?.toBase58() === entry.wallet
                  ? 'bg-orange-500/20 border border-orange-500'
                  : 'bg-[#2A3644]'
              }`}
            >
              <div className="flex items-center">
                <span className="text-xl font-bold text-yellow-400 code-mono">
                  #{index + 1}
                </span>
              </div>
              <div className="flex items-center">
                <div className="text-sm code-mono">
                  {entry.wallet.slice(0, 4)}...{entry.wallet.slice(-4)}
                </div>
              </div>
              <div className="flex items-center justify-center font-bold code-mono">
                {entry.wins}
              </div>
              <div className="flex items-center justify-center">
                <span className="text-sm text-gray-400 code-mono">
                  {new Date(entry.timestamp).toLocaleDateString()}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Leaderboard; 